import { UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Modal, Tabs, notification } from "antd"
import { useEffect, useState, useRef } from "react";
import { TabPane } from "semantic-ui-react";
import apiDocumentos from "../../../api/Documentos/api-documentos";
import apiJurados from "../../../api/Jurados/api-jurados";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";
import { Educacion } from "./Components/Educacion";
import { Experiencia } from "./Components/Experiencia";
import { PerfilJurado } from "./Components/PerfilJurado";
import { RecoPubli } from "./Components/RecoPubli";
import { Formulario } from "./Components/Formulario";
import { ObjNotificaciones } from "../../../config/notificaciones";
import { Observaciones } from "./Components/Observaciones";
import JSZip from 'jszip';
import getStorageUser from "../../../middlewares/GetStorageUser";

export const ModalVerMasJurado = ({ openModal, setOpenModal, idJurado, radicado, observaciones, estado, setEstado, idPostulacion, obtenerJurados, areaPrincipal, tipoPostulacion, docJurado, buscarFiltros, postulacionData }: any) => {
  const onCancel = () => {
    setOpenModal(false);
  }
  const [juradoPostulacion, setJuradoPostulacion] = useState<any>({});
  const [jurado, setJurado] = useState<any>({});

  const [fotoJurado, setFotoJurado] = useState<any>()

  const [viewData, setViewData] = useState(false);

  const [isDownloading, setIsDownloading] = useState(false);
  const exportFnRef = useRef<any>(null);
  const registerExportFn = (fn: any) => {
    exportFnRef.current = fn;
  };

  const obtenerPostulacionPorCodigo = async () => {
    try {
      let response: any;
      if (postulacionData) {
        response = { data: postulacionData };
      } else {
        response = await apiParticipantes.consultarPostulacionCodigo(radicado);
      }

      if (response?.data) {
        const convocatoria = await apiConvocatorias.getConvocatoriaById(response.data.convocatoria_id);
        if (convocatoria?.data) {
          const fecha_informeRaw = convocatoria.data.fechas
            ?.filter((item: any) => item.clave === "Primer informe de verificación de documentos")[0]
            ?.valormax ?? null;

          if (fecha_informeRaw !== null && !isNaN(Date.parse(fecha_informeRaw))) {
            const fechaInforme = new Date(fecha_informeRaw);
            fechaInforme.setMinutes(fechaInforme.getMinutes() + 1);
            const fechaActual = new Date();
            const user = getStorageUser();
            if (fechaActual < fechaInforme && user.role_id === 3) {
              response.data.observaciones = "";
            }
          }
        }
      }

      console.log('juradoPostulacion== ', response)
      setJuradoPostulacion(response)
      return response; // Devolver el resultado para Promise.all
    } catch (error) {
      console.log(error);
      throw error; // Propagar el error para Promise.all
    }
  }

  const obtenerJuradoPorId = async () => {
    try {
      const jurado = await apiJurados.obetenerJuradoDocumento(docJurado);
      console.log('jurado== ', jurado)
      console.log('idJurado== ', idJurado)
      if (jurado.path_foto !== null) {
        const data = await apiDocumentos.consultarArchivo(jurado.path_foto);
        if (data?.data) {
          const reader = new FileReader();
          reader.readAsDataURL(data.data);
          reader.onloadend = function () {
            const base64String = reader.result;
            setFotoJurado(base64String);
          }
        }
      }
      setJurado(jurado);
      return jurado; // Devolver el resultado para Promise.all
    } catch (error) {
      console.log(error);
      throw error; // Propagar el error para Promise.all
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      Promise.all([obtenerPostulacionPorCodigo(), obtenerJuradoPorId()])
        .then(([postulacion, jurado]) => {
          // Ambas promesas se han resuelto correctamente
          setViewData(true);
        })
        .catch((error) => {
          // Al menos una promesa ha sido rechazada
          console.error(error);
        });
    }
    return () => {
      mounted = false;
    };
  }, []);

  const descargar = async () => {
    setIsDownloading(true);
    const zip = new JSZip();
    try {
      if (juradoPostulacion.data.documentos_administrativos) {
        await Promise.all(
          juradoPostulacion.data.documentos_administrativos.map(async (documento, index) => {
            try {
              if (documento.descripcion === "Declaración de Residencia" || documento.tipo_documento === "Declaración de Residencia") {
                // Se genera al descargar el pdf embebido (abajo)
              } else {
                const response = await apiDocumentos.consultarArchivo(documento.url_participante);
                if (response?.data != null && response.data !== '') {
                  zip.folder('administrativo').file(`administrativos${index + 1}.pdf`, response.data);
                }
              }
            } catch (error) {
              console.error(`Error al descargar el documento administrativo ${index + 1}:`, error);
            }
          })
        );
      }
      if (jurado.educacion_formal) {
        await Promise.all(
          jurado.educacion_formal.map(async (documento, index) => {
            try {
              const response = await apiDocumentos.consultarArchivo(documento.path_anexo);
              if (response?.data != null && response.data !== '') {
                zip.folder('educacion').file(`educacionFormal${index + 1}.pdf`, response.data);
              }
            } catch (error) {
              console.error(`Error al descargar el documento de educación formal ${index + 1}:`, error);
            }
          })
        );
      }
      if (jurado.educacion_no_formal) {
        await Promise.all(
          jurado.educacion_no_formal.map(async (documento, index) => {
            try {
              const response = await apiDocumentos.consultarArchivo(documento.path_anexo);
              if (response?.data != null && response.data !== '') {
                zip.folder('educacion').file(`educacion_no_formal${index + 1}.pdf`, response.data);
              }
            } catch (error) {
              console.error(`Error al descargar el documento de educación no formal ${index + 1}:`, error);
            }
          })
        );
      }
      if (jurado.experiencias_profesionales) {
        await Promise.all(
          jurado.experiencias_profesionales.map(async (documento, index) => {
            try {
              const response = await apiDocumentos.consultarArchivo(documento.documento);
              if (response?.data != null && response.data !== '') {
                zip.folder('experiencia').file(`experiencias_profesionales${index + 1}.pdf`, response.data);
              }
            } catch (error) {
              console.error(`Error al descargar el documento de experiencia profesional ${index + 1}:`, error);
            }
          })
        );
      }
      if (jurado.experiencias) {
        await Promise.all(
          jurado.experiencias.map(async (documento, index) => {
            try {
              const response = await apiDocumentos.consultarArchivo(documento.documento);
              if (response?.data != null && response.data !== '') {
                zip.folder('experiencia').file(`experiencias_como_jurado${index + 1}.pdf`, response.data);
              }
            } catch (error) {
              console.error(`Error al descargar el documento de experiencia profesional ${index + 1}:`, error);
            }
          })
        );
      }
      if (jurado.publicaciones) {
        await Promise.all(
          jurado.publicaciones.map(async (documento, index) => {
            try {
              const response = await apiDocumentos.consultarArchivo(documento.documento);
              if (response?.data != null && response.data !== '') {
                zip.folder('reconocimientosPublicaciones').file(`publicaciones${index + 1}.pdf`, response.data);
              }
            } catch (error) {
              console.error(`Error al descargar la publicación ${index + 1}:`, error);
            }
          })
        );
      }
      if (jurado.reconocimientos) {
        await Promise.all(
          jurado.reconocimientos.map(async (documento, index) => {
            try {
              const response = await apiDocumentos.consultarArchivo(documento.documento);
              if (response?.data != null && response.data !== '') {
                zip.folder('reconocimientosPublicaciones').file(`reconocimientos${index + 1}.pdf`, response.data);
              }
            } catch (error) {
              console.error(`Error al descargar el reconocimiento ${index + 1}:`, error);
            }
          })
        );
      }

      if (exportFnRef.current) {
        const extraDocs = await exportFnRef.current();
        if (extraDocs && extraDocs.length > 0) {
          extraDocs.forEach((d: any) => {
            zip.file(d.nombre, d.blob);
          });
        }
      }

      zip.generateAsync({ type: 'blob' }).then((content) => {
        const url = window.URL.createObjectURL(content);
        const a = document.createElement('a');
        a.href = url;
        a.download = juradoPostulacion.data.radicado;
        a.click();
        window.URL.revokeObjectURL(url);
        setEstado('Archivos descargados correctamente');
        setIsDownloading(false);
      });
    } catch (error) {
      console.error('Error general al descargar los archivos:', error);
      setEstado('Error al descargar los archivos');
      setIsDownloading(false);
    }
  };


  const guardar = async () => {
    try {
      console.log('juradoPostulacion.observaciones -->', juradoPostulacion.data.observaciones)
      if (juradoPostulacion.data.observaciones !== null) {
        await apiParticipantes.actualizarObservacion(idPostulacion, juradoPostulacion.data.observaciones);
      } else {
        return ObjNotificaciones.MSG_ERROR('warning', '¡Ingresa las observaciones!', 'Debes indicar las observaciones cuando solicitas la subsanación de algún documento')
      }
      console.log('juradoPostulacion.data.documentos_administrativos', juradoPostulacion.data.documentos_administrativos)
      const docadm = juradoPostulacion.data.documentos_administrativos == null ? [] : juradoPostulacion.data.documentos_administrativos

      if (docadm.length == 0) {
        // agregar documentos si no tiene los campos
        //const array = [{ "id": 6, "idconvocatoria": "", "url_documento": "", "descripcion": "RUT", "subsanable": false, "obligatorio": false, "tipo_documento_id": 6, "tipo_persona": 0, "url_participante": "", "checksubsanable": true, "checkaceptar": false, "checkcancelar": false, "id_postulacion": idPostulacion }, { "id": 3, "idconvocatoria": "", "url_documento": "", "descripcion": "Cédula de ciudadanía", "subsanable": false, "obligatorio": false, "tipo_documento_id": 3, "tipo_persona": 0, "url_participante": "", "checksubsanable": true, "checkaceptar": false, "checkcancelar": false, "id_postulacion": idPostulacion }, { "id": 4, "idconvocatoria": "", "url_documento": "", "descripcion": "Declaración de Residencia", "subsanable": false, "obligatorio": false, "tipo_documento_id": 4, "tipo_persona": 0, "firma_declaracion": "", "checksubsanable": true, "checkaceptar": false, "checkcancelar": false, "id_postulacion": idPostulacion }, { "id": 185, "idconvocatoria": "", "url_documento": "", "descripcion": "Registro Único Nacional de Agentes Culturales - SOY CULTURA", "subsanable": false, "obligatorio": false, "tipo_documento_id": 185, "tipo_persona": 0, "url_participante": "", "checksubsanable": true, "checkaceptar": false, "checkcancelar": false, "id_postulacion": idPostulacion }]
        const array = []
        await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
          idPostulacion,
          array
        )
      }
      if (docadm.length > 0) {
        await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
          idPostulacion,
          juradoPostulacion.data.documentos_administrativos
        )
      }
      let estadoNuevo = "Aceptó";
      let documentosadminaceptar = [];
      let documentosadminrechazar = [];
      let documentosadminsubsanar = [];
      if (juradoPostulacion.data.documentos_administrativos) {
        documentosadminrechazar = juradoPostulacion.data.documentos_administrativos.map((x: any) => x.checkcancelar);
        documentosadminsubsanar = juradoPostulacion.data.documentos_administrativos.map((x: any) => x.checksubsanable);
      }
      let rechazada = documentosadminrechazar.filter((data: any) => data === true);
      let subsanar = documentosadminsubsanar.filter((data: any) => data === true);
      if (subsanar.length > 0) estadoNuevo = "Subsanar";
      if (rechazada.length > 0) estadoNuevo = "Rechazado";
      await apiParticipantes.cambiarEstadoPostulacion({ id_postulacion: idPostulacion, estado: estadoNuevo });

      openNotification({
        titulo: "Finalizado correctamente",
        descripcion: "Se han actualizado el estado de los documentos",
        placement: "bottomRight",
      });
      onCancel();
      buscarFiltros()
    } catch (error) {
      console.log(error)
    }
  }
  const openNotification = ({ titulo, descripcion, placement }: any) => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };

  function capitalize(sentence: string) {
    if (sentence) {
      let palabraMinuscula = sentence.toLowerCase();
      return palabraMinuscula[0].toUpperCase() + palabraMinuscula.slice(1);
    }
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      title={
        <div className=" font-color-000000CC font-size-14px">Postulación a jurado<span className="ms-3 font-color-535353 font-size-14px font-family-Montserrat-Regular">código {radicado}</span></div>
      }
      width={1500}
      visible={openModal}
      onCancel={onCancel}
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144, 0.8)",
      }}
      footer={
        <div className="justify-content-flex-end">
          <Button className="button-gray-ghost order-0" onClick={onCancel}>
            Cerrar
          </Button>

          <Button className="button-gray-ghost order-0" onClick={descargar} loading={isDownloading}>
            {isDownloading ? 'Generando PDF...' : 'Descargar zip'}
          </Button>

          {estado &&
            <Button className="button-azul-radius order-1" onClick={guardar}>
              Guardar propuesta
            </Button>
          }
        </div>
      }
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-lg-4 col-xl-2 mb-3">
            <div className="row">
              <div className="col-12 col-md-3 col-lg-12">
                {fotoJurado ?
                  <Avatar size={127} src={fotoJurado} /> : <Avatar size={127} icon={<UserOutlined />} />
                }
              </div>
              <div className="col-12 col-md-9 col-lg-12">
                <div className="font-size-14px font-family-Montserrat-SemiBold mt-2">{jurado.primer_nombre} {jurado.segundo_nombre}</div>
                <div className="font-size-14px font-family-Montserrat-SemiBold">{jurado.primer_apellido} {jurado.segundo_apellido}</div>
                <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">Tipo de documento:{" "}
                  <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                    {jurado.tipo_identificacion}
                  </span>
                </div>
                <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">No. documento:{" "}
                  <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                    {jurado.numero_documento}
                  </span>
                </div>
                <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">Municipio:{" "}
                  <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                    {capitalize(jurado.municipio_residencia)}
                  </span>
                </div>
                <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">Departamento:{" "}
                  <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                    {capitalize(jurado.departamento_residencia)}
                  </span>
                </div>
                <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">País:{" "}
                  <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                    {capitalize(jurado.pais_nacimiento)}
                  </span>
                </div>
                <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">Cel:{" "}
                  <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                    {jurado.telefono_celular}
                  </span>
                </div>
                <div className="font-size-12px font-family-Montserrat-SemiBold font-color-535353">
                  <span className="font-family-Montserrat-Regular font-size-12px" style={{ marginLeft: '2px' }}>
                    {jurado.correo_electronico}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {viewData &&
            <div className="col-12 col-lg-8 col-xl-10">
              <Tabs defaultActiveKey="1" >
                <TabPane tab="Perfil de jurado" key="1">
                  <PerfilJurado juradoPostulacion={juradoPostulacion} jurado={jurado} areaPrincipal={areaPrincipal} registerExportFn={registerExportFn} />
                </TabPane>
                <TabPane tab="Educación" key="2">
                  <Educacion jurado={jurado} />
                </TabPane>
                <TabPane tab="Experiencia" key="3">
                  <Experiencia jurado={jurado} />
                </TabPane>
                <TabPane tab="Reconocimientos y publicaciones" key="4">
                  <RecoPubli jurado={jurado} />
                </TabPane>
                <TabPane tab="Observaciones del evaluador" key="5">
                  <Observaciones observaciones={juradoPostulacion?.data?.observaciones} estado={estado} tipoPostulacion={tipoPostulacion} setEstado={setEstado} />
                </TabPane>
                <TabPane tab="Formulario de inscripción" key="6">
                  <Formulario jurado={jurado} juradoPostulacion={juradoPostulacion} />
                </TabPane>
              </Tabs>
            </div>
          }
        </div>
      </div>
    </Modal>
  )
}
